<template>
  <svg
    :width="width ? width : height ? height * (23 / 13) : 23"
    :height="height ? height : width ? width * (13 / 23) : 13"
    viewBox="0 0 23 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      :fill="iconColor"
      fill-rule="evenodd"
      >
      <path d="M17.87 8.86a1.86 1.86 0 1 1 0 3.71 1.86 1.86 0 0 1 0-3.71zM5.82 8.82a1.86 1.86 0 1 1 0 3.71 1.86 1.86 0 0 1 0-3.71z"/>
      <path d="M1.97.39h18.26c.67 0 1.32.53 1.46 1.19l.73 2.66c.13.66.24 1.74.24 2.41v2.8c0 .67-.55 1.21-1.22 1.21H20.2a2.4 2.4 0 0 0-4.8 0H8.25a2.4 2.4 0 0 0-4.8 0H1.97c-.67 0-1.22-.54-1.22-1.21V1.6C.75.93 1.3.4 1.97.4zm15.39 5.35l3.33-.02c.34-.1.56-.42.48-.8l-.6-2.4a1.05 1.05 0 0 0-1-.83h-2.21v4.05zm-.84 0H12.2V1.7h4.32v4.05zm-5.16 0H7.05V1.7h4.31v4.05zM2.01 4.9c0 .47.38.84.84.84H6.2V1.7H2.85a.84.84 0 0 0-.84.84V4.9z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'bus',
  props: {
    iconColor: {
      type: String,
      default: '#FF8301',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
